import gql from 'graphql-tag'

export const GET_ADDRESSES = gql`
  query Geofences($filter: GetGeofencesFilter) {
    geofences(filter: $filter) {
      geofences {
        data {
          address
          geofenceId
          fenceName
          circData
          polyData
          type
        }
        pagination {
          page
          show
          total
        }
      }
      isSuccessful
      message
      status
      errorName
      errorCode
    }
  }
`
